namespace Solovis.Portal.TxServices {

    /*
     * TxInvestmentSummaryManager manages the set of investment summaries retrieved from the server.
     */
    export class TxInvestmentSummaryManager {

        private _portalServices: Solovis.Portal.IPortalServices;

        public _investmentIdToSummaryHolderMap: any;

        constructor(options?: {
            portalServices?: Solovis.Portal.IPortalServices;
        }) {

            if (options && options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            this._investmentIdToSummaryHolderMap = {};
        }

        public registerSummary(summary: InvestmentSummaryForTxEditing) {
            var summaryHolder = this._investmentIdToSummaryHolderMap[summary.investmentId];
            if (!summaryHolder) {
                summaryHolder = {};
                this._investmentIdToSummaryHolderMap[summary.investmentId] = summaryHolder;
            }

            summaryHolder.summary = summary;

            if (summaryHolder.callbacks) {
                $(summaryHolder.callbacks).each(function (i, callback: any) {
                    try {
                        callback(summaryHolder.summary);
                    }
                    catch (ex) {
                        console.log("TxInvestmentSummaryManager callback error");
                        console.log(ex);
                    }
                });
            }
        };

        /*
         * getSummaryAsync will request the investment summmary and callback(summary) will be called with the result.
         */
        public async getSummaryAsync(investmentId, callback?: (summary: InvestmentSummaryForTxEditing) => void): Promise<InvestmentSummaryForTxEditing> {
            var self = this;

            if (Solovis.isNull(investmentId) || isNaN(investmentId)) {
                let nullSummary: InvestmentSummaryForTxEditing = {
                    investmentId: null,
                    investmentLabel: ""
                };
                if (callback) {
                    callback(nullSummary);
                }
                return nullSummary;
            }

            var summaryHolder = this._investmentIdToSummaryHolderMap[investmentId];
            if (!summaryHolder) {
                summaryHolder = {
                    investmentId: investmentId
                };
                this._investmentIdToSummaryHolderMap[investmentId] = summaryHolder;
            }

            if (summaryHolder.summary) {
                if (callback) {
                    callback(summaryHolder.summary);
                }

                return summaryHolder.summary;
            }
            else {
                if (!summaryHolder.callbacks) {
                    summaryHolder.callbacks = [];
                }

                if (callback) {
                    summaryHolder.callbacks.push(callback);
                }

                if (!summaryHolder.loadPending) {
                    summaryHolder.loadPending = true;

                    try {
                        let response = await this._portalServices.rpc().invoke(
                            "~/DataManagement/TransactionEditor/GetInvestmentSummary",
                            {
                                investmentId: investmentId,
                            });

                        let summary: InvestmentSummaryForTxEditing = response.result;
                        
                        this.registerSummary(summary);

                        return summary;
                    }
                    finally {
                        summaryHolder.loadPending = false;
                    }
                }
                else if (!callback) {
                    // We called using async/await style and need to register callback to make sure we get called when prior load completes.
                    return new Promise<InvestmentSummaryForTxEditing>(function (resolve, reject) {
                        summaryHolder.callbacks.push((summary) => {                            
                            resolve(summary);
                        });
                    });
                }
            }
        };
    }

}
